(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["huna-article-head"] && !Shopify.designMode) return;
  try {
    
(function(){
  var prog=document.querySelector('.huna-prog');
  if(!prog)return;
  function upd(){var h=document.documentElement.scrollHeight-window.innerHeight;prog.style.width=(window.scrollY/h*100)+'%';}
  window.addEventListener('scroll',upd,{passive:true});upd();
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["huna-cart"] && !Shopify.designMode) return;
  try {
    
(function(){
  var pending = null;
  document.addEventListener('click', function(e) {
    var qtyBtn = e.target.closest('[data-qty]');
    if (qtyBtn) {
      e.preventDefault();
      var qtyEl = qtyBtn.parentElement;
      var input = qtyEl.querySelector('[data-qty-input]');
      if (!input) return;
      var d = parseInt(qtyBtn.getAttribute('data-qty'), 10) || 0;
      var v = Math.max(0, (parseInt(input.value, 10) || 0) + d);
      input.value = v;
      scheduleUpdate(qtyBtn.closest('[data-cart-item]'), v);
      return;
    }
    var removeBtn = e.target.closest('[data-cart-remove]');
    if (removeBtn) {
      e.preventDefault();
      var item = removeBtn.closest('[data-cart-item]');
      if (item) item.classList.add('huna-removing');
      scheduleUpdate(item, 0, true);
      return;
    }
  });

  document.addEventListener('change', function(e) {
    var input = e.target.closest('[data-qty-input]');
    if (!input) return;
    var v = Math.max(0, parseInt(input.value, 10) || 0);
    input.value = v;
    scheduleUpdate(input.closest('[data-cart-item]'), v);
  });

  function scheduleUpdate(itemEl, qty, immediate) {
    if (!itemEl) return;
    if (pending) clearTimeout(pending);
    var delay = immediate ? 200 : 600;
    pending = setTimeout(function() {
      var key = itemEl.getAttribute('data-item-key');
      fetch('/cart/change.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
        body: JSON.stringify({ id: key, quantity: qty })
      })
      .then(function(r) { return r.json(); })
      .then(function() { window.location.reload(); })
      .catch(function() { itemEl.classList.remove('huna-removing'); });
    }, delay);
  }
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["huna-contact"] && !Shopify.designMode) return;
  try {
    
(function(){
  var form = document.getElementById('huna-contact-form');
  if (!form) return;
  var btn = form.querySelector('[data-huna-contact-submit]');
  var timeInput = form.querySelector('[data-huna-contact-time]');
  if (timeInput) timeInput.value = new Date().toISOString();
  form.addEventListener('submit', function(e){
    if (timeInput) timeInput.value = new Date().toISOString();
    if (!form.checkValidity()) { return; }
    if (btn) {
      btn.disabled = true;
      var textEl = btn.querySelector('[data-huna-btn-text]');
      var loadEl = btn.querySelector('[data-huna-btn-loading]');
      if (textEl) textEl.style.display = 'none';
      if (loadEl) loadEl.style.display = 'inline-flex';
    }
  });
  if (window.location.hash === '#huna-contact-form' || form.querySelector('.huna-contact-success') || form.querySelector('.huna-contact-error')) {
    setTimeout(function(){
      form.scrollIntoView({ behavior: 'smooth', block: 'start' });
    }, 100);
  }
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["huna-header"] && !Shopify.designMode) return;
  try {
    
(function(){
  document.addEventListener('click',function(e){
    if (e.target.closest('[data-huna-mm-toggle]')) { document.body.classList.toggle('huna-mm-open'); return; }
    if (e.target.closest('[data-huna-mm-close]')) { document.body.classList.remove('huna-mm-open'); return; }
    if (document.body.classList.contains('huna-mm-open') && e.target.closest('.huna-mm-link')) { document.body.classList.remove('huna-mm-open'); }
  });
  document.addEventListener('cart:updated', function(){ fetchCart(); });
  function fetchCart(){
    fetch('/cart.js').then(function(r){return r.json();}).then(function(c){
      document.querySelectorAll('[data-huna-cart-count]').forEach(function(el){ el.textContent = c.item_count; });
    });
  }
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["huna-pdp-main"] && !Shopify.designMode) return;
  try {
    
(function(){
  document.addEventListener('click',function(e){
    var t=e.target.closest('.huna-pdp-thumb'); if(!t)return;
    var src=t.getAttribute('data-huna-img'); var target=document.getElementById(t.getAttribute('data-huna-target'));
    if(target){var img=target.querySelector('img'); if(img)img.src=src;}
    t.parentNode.querySelectorAll('.huna-pdp-thumb').forEach(function(b){b.classList.remove('huna-sel');}); t.classList.add('huna-sel');
  });
  document.addEventListener('click',function(e){
    var b=e.target.closest('[data-huna-qty]'); if(!b)return;
    var form=b.closest('[data-huna-pdp-form]'); if(!form)return;
    var d=parseInt(b.getAttribute('data-huna-qty'),10)||0;
    var disp=form.querySelector('[data-huna-qty-display]'); var inp=form.querySelector('[data-huna-qty-input]');
    var v=Math.max(1,(parseInt(disp.textContent,10)||1)+d);
    disp.textContent=v; if(inp)inp.value=v;
    updateTotal(form);
  });
  document.addEventListener('change',function(e){
    var s=e.target.closest('.huna-pdp-variant'); if(!s)return;
    updateTotal(s.closest('[data-huna-pdp-form]'));
  });
  function fmt(amount){var clp=Math.round(amount/100); return '$'+clp.toString().replace(/\B(?=(\d{3})+(?!\d))/g,'.');}
  function updateTotal(form){
    if(!form)return;
    var base=parseInt(form.getAttribute('data-base-price'),10)||0;
    var sel=form.querySelector('.huna-pdp-variant');
    if(sel){var op=sel.options[sel.selectedIndex]; if(op&&op.getAttribute('data-price')){base=parseInt(op.getAttribute('data-price'),10);}}
    var qty=parseInt(form.querySelector('[data-huna-qty-input]').value,10)||1;
    var disp=form.querySelector('[data-huna-total]'); if(disp)disp.textContent=fmt(base*qty);
  }
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["huna-popup"] && !Shopify.designMode) return;
  try {
    
(function(){
  var popup = document.getElementById('huna-popup');
  if (!popup) return;
  var STORAGE_KEY_SUBSCRIBED = 'huna_popup_subscribed';
  var STORAGE_KEY_DISMISSED = 'huna_popup_dismissed_at';
  var delay = parseInt(popup.dataset.delay, 10) * 1000 || 5000;
  var scrollPercent = parseInt(popup.dataset.scroll, 10) || 40;
  var suppressDays = parseInt(popup.dataset.suppressDays, 10) || 7;
  var triggered = false;
  var formEl = popup.querySelector('#huna-popup-form') || popup.querySelector('form');
  var emailInput = popup.querySelector('[data-huna-popup-email]');
  var submitBtn = popup.querySelector('[data-huna-popup-submit]');
  var errorEl = popup.querySelector('[data-huna-popup-error]');
  var formState = popup.querySelector('[data-state="form"]');
  var successState = popup.querySelector('[data-state="success"]');
  var copyBtn = popup.querySelector('[data-huna-popup-copy]');
  var copyTextEl = popup.querySelector('[data-huna-popup-copy-text]');
  var codeDisplay = popup.querySelector('[data-huna-popup-code-display]');

  function shouldSuppress() {
    try {
      if (localStorage.getItem(STORAGE_KEY_SUBSCRIBED) === '1') return true;
      var dismissedAt = parseInt(localStorage.getItem(STORAGE_KEY_DISMISSED), 10);
      if (dismissedAt && (Date.now() - dismissedAt) < suppressDays * 86400000) return true;
    } catch(e) {}
    return false;
  }

  function openPopup() {
    if (triggered) return;
    if (shouldSuppress()) return;
    triggered = true;
    popup.hidden = false;
    requestAnimationFrame(function(){ popup.classList.add('is-open'); });
    document.documentElement.style.overflow = 'hidden';
    setTimeout(function(){ if (emailInput) emailInput.focus(); }, 400);
  }

  function closePopup(opts) {
    opts = opts || {};
    popup.classList.remove('is-open');
    document.documentElement.style.overflow = '';
    setTimeout(function(){ popup.hidden = true; }, 350);
    if (!opts.skipSuppression) {
      try { localStorage.setItem(STORAGE_KEY_DISMISSED, Date.now().toString()); } catch(e) {}
    }
  }

  // Detect server-side success or error state from Liquid render
  var justSubmitted = popup.querySelector('[data-huna-popup-just-submitted]');
  var renderedError = popup.querySelector('[data-huna-popup-error]:not([hidden])');
  var skipNormalTrigger = false;

  if (justSubmitted) {
    if (formState) formState.hidden = true;
    if (successState) successState.hidden = false;
    triggered = true;
    popup.hidden = false;
    requestAnimationFrame(function(){ popup.classList.add('is-open'); });
    try { localStorage.setItem(STORAGE_KEY_SUBSCRIBED, '1'); } catch(e) {}
    document.documentElement.style.overflow = 'hidden';
    skipNormalTrigger = true;
  } else if (renderedError && renderedError.textContent.trim().length > 0) {
    triggered = true;
    popup.hidden = false;
    requestAnimationFrame(function(){ popup.classList.add('is-open'); });
    document.documentElement.style.overflow = 'hidden';
    skipNormalTrigger = true;
  }

  if (!skipNormalTrigger && !shouldSuppress()) {
    var timer = setTimeout(openPopup, delay);
    var onScroll = function(){
      var scrollTop = window.pageYOffset || document.documentElement.scrollTop;
      var maxScroll = (document.documentElement.scrollHeight || 0) - window.innerHeight;
      if (maxScroll <= 0) return;
      var pct = (scrollTop / maxScroll) * 100;
      if (pct >= scrollPercent) {
        clearTimeout(timer);
        window.removeEventListener('scroll', onScroll);
        openPopup();
      }
    };
    window.addEventListener('scroll', onScroll, { passive:true });
  }

  popup.addEventListener('click', function(e){
    if (e.target.closest('[data-huna-popup-close]')) { closePopup(); }
  });

  document.addEventListener('keydown', function(e){
    if (e.key === 'Escape' && popup.classList.contains('is-open')) { closePopup(); }
  });

  // Native submit — let Shopify handle, page reloads, server-side check above shows success
  if (formEl) {
    formEl.addEventListener('submit', function(e){
      if (!formEl.checkValidity()) { return; }
      submitBtn.disabled = true;
      var textEl = submitBtn.querySelector('[data-huna-btn-text]');
      var loadEl = submitBtn.querySelector('[data-huna-btn-loading]');
      if (textEl) textEl.style.display = 'none';
      if (loadEl) loadEl.style.display = 'inline-flex';
    });
  }

  if (copyBtn && codeDisplay) {
    copyBtn.addEventListener('click', function(){
      var code = codeDisplay.textContent.trim();
      var done = function(){
        copyBtn.classList.add('is-copied');
        var prev = copyTextEl ? copyTextEl.textContent : '';
        if (copyTextEl) copyTextEl.textContent = '¡Copiado!';
        setTimeout(function(){
          copyBtn.classList.remove('is-copied');
          if (copyTextEl) copyTextEl.textContent = prev;
        }, 2000);
      };
      if (navigator.clipboard && navigator.clipboard.writeText) {
        navigator.clipboard.writeText(code).then(done).catch(function(){
          try {
            var t = document.createElement('textarea');
            t.value = code; document.body.appendChild(t); t.select();
            document.execCommand('copy'); document.body.removeChild(t); done();
          } catch(e) {}
        });
      }
    });
  }
})();

  } catch(e) { console.error(e); }
})();
})();
